import {get} from 'lodash'
import webvarsConfigurationService from 'common/services/webvarsConfigurationService'
import {createLogger as createPowtoonLogger} from 'powtoon-commons/logger'
import cookie from 'cookie'
import uuid from 'uuid'
import {getCorePlayerImports} from 'powtoon-html-player/src/CorePlayerImports'
const {getWebVar} = webvarsConfigurationService
const logzioId = getWebVar('logzio_id')
const logLevel = getWebVar('min_log_level')
const appLevel = getWebVar('appLevel')
const isProdEnv = getWebVar('isProdEnv')
let {visitorid: visitorId, sessionid: sessionId} = cookie.parse(document.cookie)
let powtoonId = get(window.location.hash.match(/\/edit\/(.*)$/), '[0]')
let userId


const data = {
  logzioId,
  appName: process.env.ENTRY_POINT_NAME,
  appVersion: process.env.BUILD_IDENTIFIER,
  appLevel: appLevel || 'n.a',
  userAgent: window.navigator.userAgent,
  tabId: uuid(),
  client_ip: getWebVar('clientIP'),
  get powtoonId() {
    return powtoonId || 'n.a'
  },
  set powtoonId(value) {
    powtoonId = value
  },
  get userId() {
    return userId || 'n.a'
  },
  set userId(value) {
    userId = value
  },
  get sessionId() {
    return sessionId || 'n.a'
  },
  set sessionId(value) {
    sessionId = value
  },
  get visitorId() {
    return visitorId || 'n.a'
  },
  set visitorId(value) {
    visitorId = value
  }
}

getCorePlayerImports().then(CorePlayerImports => {
  data.corePlayerVersion = CorePlayerImports.getVersion()
})


const logConfig = {
  logLocally: !isProdEnv,
  logRemotely: !!logzioId,
  logLevel: !logLevel && isProdEnv ? 'log' : logLevel
}

export const setUserIdentity = ({userId, powtoonId, sessionId, visitorId}) => {
  data.userId = userId
  data.powtoonId = powtoonId
  data.sessionId = sessionId
  data.visitorId = visitorId
}

export const createLogger = (moduleName, loggerName) =>
  createPowtoonLogger({moduleName, loggerName}, data, logConfig)
